/**
 * Handle changes in the dropdown by refreshing the page
 */
function initOrder(){
    const select = document.querySelector('#widget-tags-main-order');
    // TODO change or input?
    select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('order', select.selectedOptions[0].value);
        window.location.href = url.href;
    });
}

/**
 * Handle clicks on the tag items - updates the URL so the browser goes to new
 * URl
 */
function initLinks() {
    const tagList = document.querySelector('.tag-overview-list');

    tagList.addEventListener('click', function(event) {
        const clickedLink = event.target.closest('.kf-internal.link');

        if(clickedLink) {
            event.preventDefault();
            const tagElement = clickedLink.querySelector('.tag');
            const parentListItem = clickedLink.closest('.tag-item');
            parentListItem.classList.toggle('active-tag');
            updateUrl(tagElement);
        }
    });

    function updateUrl(tagElement) {
        const tag = tagElement.textContent.trim();
        const url = new URL(window.location.href);
        const tagParam = url.searchParams.get('tag');
        const tags = tagParam ? tagParam.split(',') : [];
        const tagIndex = tags.indexOf(tag);

        if (tagIndex === -1) {
            tags.push(tag);
            tagElement.closest('li').classList.add('active-tag');
        } else {
            tags.splice(tagIndex, 1);
            tagElement.closest('li').classList.remove('active-tag');
        }

        url.searchParams.set('tag', tags.join(','));
        window.location.href = url.href;
    }
}

/**
 * Class that handles links on the tags page
 */
export class Tags {
    init() {
        initLinks();
        initOrder();
    }
}
